import { Input } from '@material-tailwind/react';

const MeritsInput = (props) => {
  const { label, required, placeholder, type, value, onChange } = props;
  return (
    <div>
      <div className="block text-sm font-semibold text-gray-800 mb-2">
        {required ? <sup className="text-red-500">*</sup> : ''}
        {label}
      </div>
      <Input
        type={type}
        color="blue-gray"
        size="md"
        variant="outlined"
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default MeritsInput;
